import styled from 'styled-components';
import { unthemed } from 'tokens';

export const Base = styled.div<{ selected?: boolean }>`
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 8px 8px;
	border-radius: 6px;
	transition: background 0.2s;
	background: ${({ selected, theme }) => (selected ? theme.gray[100] : 'transparent')};

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

export const IconWrapper = styled.div`
	width: 32px;
	height: 32px;
	background: linear-gradient(135deg, #1e90ff 0%, #4169e1 100%);
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${unthemed.gray[0]};
	font-size: 14px;
	font-weight: 600;
	flex-shrink: 0;
`;

export const Content = styled.div`
	flex: 1;
	min-width: 0;
`;

export const Name = styled.div`
	font-size: 12px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	margin-bottom: 2px;
`;
